import { render, staticRenderFns } from "./InputMultiSelect.vue?vue&type=template&id=f65d4e54"
import script from "./InputMultiSelect.vue?vue&type=script&lang=js"
export * from "./InputMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports